export const formStructure = [[{
  name: 'nome',
  label: 'Nome',
  placeholder: 'Digite o nome do cliente',
  component: 'FormField',
  type: 'text',
  colProps: {
    md: 6
  },
  required: true
}, {
  name: 'cnpj',
  label: 'CNPJ',
  placeholder: 'Digite o CNPJ',
  component: 'MaskedInput',
  type: 'text',
  colProps: {
    md: 6
  },
  mask: [/[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/],
  guide: false
}], [{
  name: 'codigoIntegracao',
  label: 'Código de Integração',
  placeholder: 'Digite o código de integração',
  component: 'FormField',
  type: 'text',
  colProps: {
    md: 6
  }
}, {
  name: 'telefone',
  label: 'Telefone',
  placeholder: 'Digite o telefone',
  component: 'MaskedInput',
  type: 'text',
  colProps: {
    md: 6
  },
  mask: ['(', /[0-9]/, /[0-9]/, ')', ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
  guide: false
}], [{
  name: 'email',
  label: 'Email',
  placeholder: 'Digite o email do cliente',
  component: 'FormField',
  type: 'email',
  colProps: {
    md: 12
  }
}], [{
  name: 'observacoes',
  label: 'Observações',
  placeholder: 'Digite as observações',
  component: 'Textarea',
  type: 'textarea',
  colProps: {
    md: 12
  },
  rows: 4
}], [{
  name: 'dataCriacao',
  label: 'Data de Criação',
  placeholder: 'Data de criação',
  component: 'DatePickers',
  type: 'date',
  colProps: {
    md: 6
  },
  disabled: true,
  allowClear: false
}, {
  name: 'dataModificacao',
  label: 'Última Modificação',
  placeholder: 'Data da última modificação',
  component: 'DatePickers',
  type: 'date',
  colProps: {
    md: 6
  },
  disabled: true,
  allowClear: false
}]];
export const formSections = initialValues => [{
  title: `Detalhes do Cliente ${initialValues.nome || ''}`,
  rows: [0] // Nome e CNPJ

}, {
  title: 'Informações Adicionais',
  rows: [1, 2, 3] // Código de integração, telefone, email e observações

}, {
  title: 'Datas do Sistema',
  rows: [4] // Datas de criação e modificação

}];
